/* eslint-disable max-len */
import React, { useState,useContext } from 'react';
import CustomOverLay from '../../../../../components/CustomOverLay';
import GlobalContext from '../../../../../components/Context/GloablContext';
import Emptyscreenwithouttitle from '../../../../../components/Emptyscreenwithouttitle';
import { useGetObserversAssociatedToPatientListQuery } from '../../../../../slices/patientSlice';
import formatMobileNumber from '../../../../../CommonMethods/FormatMobileNumber';

export default function ObserverViewTable({patient_id}) {
    const {isSideBar} = useContext(GlobalContext);
    const [queryParams,setQueryParams]=useState(`${patient_id}`)
    const {data,isFetching,isLoading,status}=useGetObserversAssociatedToPatientListQuery(patient_id,{refetchOnMountOrArgChange:true})

    return (
        <>  
            {<>
                <div className='border border-[#EDD7E1] mt-4 rounded'>
                    <div className='relative flex border-b border-[#EDD7E1] justify-between items-center py-3.5 pr-4 pl-[18px]'>
                        <p className='text-base font-semibold text-[#972E4C]' id="Observer-List">Care Partners List</p>
                    </div>
                    {data?.data && data?.data.length === 0
                        ? <Emptyscreenwithouttitle customHeight={false} FirstPTag={"No care partners linked yet"} />
                        :
                        <div data-testid='Observer-table' className='overflow-auto scrollbar_purple pb-2'>
                            { ((isFetching&&status!=="fulfilled"&&status!=="rejected")||(isLoading)||(data===undefined&&status!=="fulfilled"&&status!=="rejected"))?<CustomOverLay Active text="Loading Care Partner List..." classKey={` top-0 left-0 right-0 z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center w-auto ${isSideBar?'opened_sidebar_overlay2':'overlay-list2'}`}/>: <>
                                <table aria-label="Outside Table" className="w-full table-auto">
                                    <thead>
                                        <tr className="h-[38px] w-full bg-[#EDD7E1] rounded-sm sticky top-[0px] left-0 z-[1]">
                                            <th className="px-[18px] py-2 rounded-tl-sm rounded-bl-sm  min-w-[100px] text-start">
                                                <label htmlFor="top-id" className="text-sm font-normal text-[#031624] w-full cursor-pointer">ID</label>
                                                                
                                            </th>
                                            <th id="last" className="px-[18px] py-2 min-w-[140px] rounded-tl-sm rounded-bl-sm">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000] ">Username
                                                </span>
                                            </th>
                                            <th id="status" className="px-[18px] py-2 min-w-[180px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]" >Name
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[150px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Email Address
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[150px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Mobile Number
                                                </span>
                                            </th>
                                            <th className="px-[18px] py-2 min-w-[150px]">
                                                <span className="flex items-center justify-start text-sm font-normal text-[#000000]">Main Number
                                                </span>
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        
                                        {data?.data && data?.data?.length>0 && data?.data?.map((Observer, index) => (
                                            <tr key={index}>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {Observer?.user_id}
                                                    
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{Observer?.user_name}</td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {Observer?.last_name}, {Observer?.first_name}
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">{Observer?.email_address}</td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {Observer?.mobile_country_code} {formatMobileNumber(Observer?.mobile_number)}
                                                </td>
                                                <td className="px-[18px] py-2 text-sm text-start font-normal text-[#031624]">
                                                    {Observer?.main_country_code} {formatMobileNumber(Observer?.main_number)}
                                                </td>
                                                
                                            </tr>

                                        ))}
                            
                                    </tbody>
                                </table>
                    
            
                            </>}
                        </div>
                    }
                </div>
            </>}
        </>
    )
}
